import { GetOfferRequestTripDetailsForAdminState } from './getOfferRequestTripDetailsForAdmin.types'

const initialState: GetOfferRequestTripDetailsForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
